<!--
 * @Author: wbf
 * @LastEditTime: 2023-07-04 15:53:42
 * @Description: 绑定账号
-->
<template>
  <div class="box">
    <!--新增绑定账户 -->
    <div class="sheet-content" v-if="isShow">
      <Form @submit="onSubmit">
        <div class="sheetbg">
          <div class="change-title sheet-title">
            {{ $t("webapp.home.bind.account") }}
          </div>
          <Field
            v-model="changeForm.userName"
            name="userName"
            :placeholder="$t('login.username_placeholder')"
            :show-error-message="false"
            :scroll-to-error="true"
            :rules="[{ required: true }]"
          />
          <Field
            v-model="changeForm.password"
            name="password"
            type="password"
            :placeholder="$t('login.password_placeholder')"
            :show-error-message="false"
            :scroll-to-error="true"
            :rules="[{ required: true }]"
          />
        </div>
        <div style="margin-top: 30px">
          <Button round block type="info" native-type="submit">{{ $t("base.btn.bind") }}</Button>
        </div>
      </Form>
    </div>
    <!-- 绑定成功 -->
    <div class="success_main" v-else>
      <Icon name="checked" size="50" color="#52c41a" />
      <div class="success_tip">
        {{ $t("webapp.home.bind.bind_success") }}
      </div>
    </div>
  </div>
</template>

<script>
import { Form, Button, Field, NavBar, Icon } from "vant";
import { commonAPI } from "@/apis";
import { toast } from "@/utils/toast";

export default {
  name: "BindAccount",
  components: { Form, Button, Field, NavBar, Icon },
  data() {
    return {
      changeForm: { staus: 1 },
      isShow: true,
    };
  },
  created() {
    // 第三方数据传过来的，绑定应用id: bindappid ;绑定应用名称: bindrappname; 绑定用户id:otheruserid;绑定用户名: otherusername
    const data = this.$route.query;
    if (data.bindappid && data.otherusername) {
      this.changeForm.bindappid = data.bindappid;
      this.changeForm.otherusername = data.otherusername;
    } else {
      toast(this.$t("webapp.home.bind.no_app"));
    }
  },
  methods: {
    // 新增绑定账户
    async onSubmit(values) {
      if (this.changeForm.bindappid && this.changeForm.otherusername) {
        const { code, message } = await commonAPI.postAction("/other/user/save", this.changeForm);
        if (code === 0) {
          // toast(this.$t("webapp.home.bind.account_success"));
          this.isShow = false;
          setTimeout(() => {
            lightAppJssdk.navigation.close({
              success: function(data) {},
              fail: function(data) {},
            });
          }, 1500);
        } else {
          toast(message);
        }
      } else {
        toast(this.$t("webapp.home.bind.no_app"));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base.scss";
.box {
  width: 100vw;
  height: 100vh;
  padding: 12px 15px;
  .sheet-content {
    background-color: #f7f7f7;
    .sheetbg {
      background: #fff;
      box-shadow: 0px 1px 2px 1px rgba(228, 228, 228, 0.2);
      border-radius: 8px;
      padding: 10px 0;
    }
    .sheet-flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f5f5f5;
      padding: 10px 15px;
    }
    .sheet-title {
      font-size: 15px;
      font-weight: 600;
      color: #000;
      line-height: 40px;
    }
    .no-check {
      color: #3c95ff;
    }
    .change-title {
      border-bottom: 1px solid #f5f5f5;
      padding: 10px 15px;
    }
  }

  .success_main {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: #fff;
    border-radius: 10px;
    text-align: center;
    .success_tip {
      margin-top: 12px;
    }
  }
}
</style>
